<template>

  <div class="columns is-centered is-vcentered">

    <div class="column is-three-fifths-desktop is-four-fifths-tablet">

      <div class="card" style="padding: 30px 30px; margin-top: 35px;" :style="{opacity: (submitInProgress ? 0.3 : 1)}">
        <div class="card-content">

        <b-field label="Name" style="text-align: left;">
          <b-input v-model="name" v-focus placeholder="The team's name" required></b-input>
        </b-field>

        <b-field label="Short name" style="text-align: left;">
          <b-input v-model="shortName" placeholder="Short team name" required maxlength="15"></b-input>
        </b-field>

          <b-field label="Coach" style="text-align: left;">
            <b-input v-model="coach" placeholder="Coach name" required></b-input>
          </b-field>

        <p v-if="failedSubmit" style="margin-top: 27px; text-align: left; color: red;">Please make sure you complete all fields.</p>


        <div style="text-align: right;">
          <button class="button is-danger" v-if="id" style="margin-top: 25px; margin-bottom: -10px; margin-right: 30px;" @click="deleteTeam">Delete</button>
          <button class="button is-primary" style="margin-top: 25px; margin-bottom: -10px;" @click="triggerSubmit">Submit changes</button>
        </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import axios from '../request';
import TournamentDataMixin from '../mixins/TournamentDataMixin.js';

export default {
  mixins: [ TournamentDataMixin ],

  data: function() {
    return {
      name: '',
      shortName: '',
      coach: '',

      submitInProgress: false,
      failedSubmit: false
    }
  },

  computed: {
    id: function() { return this.$route.params.team; },
  },

  watch: {
    tournament: {
      immediate: true,

      handler() {
        if (this.tournament && this.id) {
          let team = this.tournament.teams.filter(team => team.id == this.id);
          if (team && team.length > 0) {
            this.name = team[0].name;
            this.shortName = team[0].shortName;
            this.coach = team[0].coach;
          }
        }
      }
    }
  },

  methods: {
    deleteTeam: function() {
      let team = this.tournament.teams.filter(team => team.id == this.id)[0];

      this.$dialog.confirm({
        message: 'Are you sure you want to delete this team?\nThis action will only succeed if there are no players defined.',
        type: 'is-danger',
        onConfirm: () => { this.$store.dispatch('deleteItem', { type: 'team', item: team }); }
      });
    },

    triggerSubmit: function() {

      if (this.submitInProgress) {
        return /* don't do multiple requests */;
      }

      let vm = this;
      vm.submitInProgress = true;
      vm.failedSubmit = false;

      let tournamentId = this.$route.params.id;

      axios.post('/api/tournament/' + tournamentId + '/teams', {
        name: this.name,
        shortName: this.shortName,

        coach: this.coach,
        id: this.id
      })
        .then(function(response){
          vm.submitInProgress = false;
          vm.failedSubmit = false;

          vm.$store.dispatch('tournamentTeamsChanged', { tournamentId: tournamentId, teams: response.data });
        })
        .catch(function(){
          vm.submitInProgress = false;
          vm.failedSubmit = true;
        });

    }
  },

  name: 'edit-teams'
}
</script>



<style scoped>

</style>